class CustomPopup extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      popupHeader: this.querySelector(".popup-header"),
      popupPage: this.querySelector(".popup-page"),
      closeButton: this.querySelector('.close-button'),
    }
    
    if (this.elements.popupHeader) {
      this.elements.popupHeader.addEventListener("click", () => this.showPopup());
    }
    if (this.elements.closeButton) {
      this.elements.closeButton.addEventListener('click', () => this.closePopup());
    }
  }

  showPopup() {
    if (this.elements.popupPage) {
      this.elements.popupPage.classList.add("active");
    }
    if (this.elements.popupHeader) {
      this.elements.popupHeader.classList.add("active");
    }
  }
  
  closePopup() {
    if (this.elements.popupPage) {
      this.elements.popupPage.classList.remove("active");
    }
    if (this.elements.popupHeader) {
      this.elements.popupHeader.classList.remove("active");
    }
  }
}

customElements.define('custom-popup', CustomPopup);
